import { __ } from "@wordpress/i18n";
import { useSettingsContext } from "../../../hook/useSettingsContext";

export default function QuantityButton({ type = "plus", children }) {
    const {
        previewOptions,
        quantity,
        handleDecrease,
        handleIncrease,
        getOption,
        setShowMinAlert,
        setShowMaxAlert,
    } = useSettingsContext();

    const isMinDisabled = quantity <= previewOptions.minValue;
    const isMaxDisabled =
        previewOptions.maxValue !== null && quantity >= previewOptions.maxValue;

    const disabled = type === "plus" ? isMaxDisabled : isMinDisabled;

    const onClick = type === "plus" ? handleIncrease : handleDecrease;

    const handleClick = (e) => {
        if (disabled) {
            if (type === "plus") {
                setShowMaxAlert?.(true);
            } else {
                setShowMinAlert?.(true);
            }
            return;
        }

        onClick?.(e);
    };

    const classes = `wpb-pmqb-qty-btn ${
        type === "plus" ? "plus wpb-pmqb-qty-plus" : "minus wpb-pmqb-qty-minus"
    }`;

    const ariaLabel =
        type === "plus"
            ? __(
                  "Increase quantity",
                  "wpbean-quantity-controls-for-woocommerce",
              )
            : __(
                  "Decrease quantity",
                  "wpbean-quantity-controls-for-woocommerce",
              );

    return (
        <button
            type="button"
            className={
                classes + (disabled ? " wpb-pmqb-qty-btn--disabled" : "")
            }
            aria-label={ariaLabel}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            onClick={handleClick}
        >
            {children}
        </button>
    );
}
